// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"reserve_pageContainer__23gMt","noticeWrapper":"reserve_noticeWrapper__2cbdn","mainContent":"reserve_mainContent__1l0g_","stashBtn":"reserve_stashBtn__2MRWF"};